import one from '@mailobj-browser/front/js/selectors/one.js'
import ea_rte_iframe from './ea_rte_iframe.js'
import confirm from '../confirm.js'

export default async (rte, {
  link = '',
  repeat = '',
  attach = '',
  pos = '',
  bkg = '',
  color = '',
  padding = ''
} = {}) => {
  const iframe = await ea_rte_iframe(rte)
  const { contentDocument, contentWindow, dataset, ownerDocument } = iframe
  const { modified } = dataset
  const { body } = contentDocument
  const { style } = body
  const hdn = one(`#rte_${rte}_hdn_bkg`, ownerDocument)
  
  if (link) {
    Object.assign(style, {
      backgroundImage: `url("${link}")`,
      backgroundRepeat: repeat,
      backgroundAttachment: attach,
      backgroundPosition: pos,
      backgroundColor: bkg,
      color: color,
      padding: padding,
    })
  }

  /*
    if (!link) {
      style.backgroundImage = `url("${link}")`
      style.backgroundRepeat = repeat
      style.backgroundAttachment = attach
      style.backgroundPosition = pos
      style.backgroundColor = bkg
      style.color = color
      style.padding = padding
    } else {
      body.setAttribute('style', '')
    }
  */

  if (hdn) {
    hdn.value = body.getAttribute('style')
  }
  
  if (modified) {
    await confirm(modified)
  }
  
  contentWindow.focus()
}
